'use client';
import { usePaymentMethod } from '@payments-checkout/shared/providers';

export function usePreselectVariant() {
  const { preselectExperiment, paymentMethod, selectedDigitalWallet } =
    usePaymentMethod();
  const hasSelection = !!paymentMethod || !!selectedDigitalWallet;

  return {
    isLoading: preselectExperiment === 'pending',
    skipPreselect: preselectExperiment === 'treatment',
    showPaymentDetails:
      preselectExperiment === 'control' ||
      (preselectExperiment === 'treatment' && hasSelection),
  };
}
